module.exports = __webpack_public_path__ + "static/media/tasks.607db11a.png";


//////////////////
// WEBPACK FOOTER
// ../images/screenshots/tasks.png
// module id = 652
// module chunks = 0